import escapeHTML from 'escape-html';
import { marked } from 'marked';
import showdown from 'showdown';

const customExtension: showdown.ShowdownExtension = {
  type: 'output',
  filter: (text, converter, options) => {
    // 정규 표현식을 사용하여 ==로 감싸진 부분을 <mark> 태그로 대체합니다.
    const regex = /==([^=]+)==/g;
    text = text.replace(regex, '<mark>$1</mark>');
    return text;
  },
};

const converter = new showdown.Converter({ extensions: [customExtension] });
converter.setOption('strikethrough', true);

export const parse = (markdown: string) => {
  const escape = escapeHTML(markdown);
  const parser = new DOMParser();
  const doc = parser.parseFromString(
    // marked.parse(markdown, { gfm: true, sanitize: true }),
    converter.makeHtml(escape),
    'text/html',
  );

  for (const element of doc.getElementsByTagName('ol')) {
    let elem = element as HTMLElement;
    let index = 0;
    for (;;) {
      if (
        elem.parentElement?.tagName === 'OL' ||
        elem.parentElement?.tagName === 'UL'
      ) {
        index += 1;
      } else if (elem.parentElement?.tagName === 'BODY') {
        break;
      }
      if (!elem.parentElement) break;
      elem = elem.parentElement;
    }
    switch (index % 3) {
      case 0:
        break;
      case 1:
        element.type = 'a';
        break;
      case 2:
        element.type = 'i';
        break;
    }
  }
  return doc.documentElement.innerHTML
    .replaceAll('%%EMPTYLINE%%', '<br/>')
    .replaceAll(
      '%%LINE%%',
      '<div style="border: 1px solid; width: 100%;"></div>',
    );
};

export default marked;
